'use client';

import { type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

export type ResultContentType = 'video' | 'audio';

interface ResultTypeToggleProps {
    value: ResultContentType;
    onChange: (type: ResultContentType) => void;
    videoCount: number;
    audioCount: number;
    className?: string;
}

interface ToggleTabProps {
    label: string;
    count: number;
    isActive: boolean;
    onClick: () => void;
}

function ToggleTab({ label, count, isActive, onClick }: ToggleTabProps): JSX.Element {
    return (
        <button
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={onClick}
            className={twMerge(
                'flex grow items-center justify-center gap-1.5 rounded-md px-2 py-1 text-sm font-medium text-gray-950 cursor-pointer',
                isActive && 'bg-white border border-gray-200 shadow-sm',
            )}
        >
            {label}
            <span className="inline-flex items-center justify-center min-w-5 rounded-full bg-gray-100 px-1 py-0.5 text-sm font-medium text-gray-950">
                {count}
            </span>
        </button>
    );
}

export function ResultTypeToggle({
    value,
    onChange,
    videoCount,
    audioCount,
    className,
}: ResultTypeToggleProps): JSX.Element {
    return (
        <div
            role="tablist"
            aria-label="Result type"
            className={twMerge('inline-flex items-center gap-0.5 rounded-lg bg-gray-100 p-[3px]', className)}
        >
            <ToggleTab
                label="Video"
                count={videoCount}
                isActive={value === 'video'}
                onClick={() => onChange('video')}
            />
            <ToggleTab
                label="Audio"
                count={audioCount}
                isActive={value === 'audio'}
                onClick={() => onChange('audio')}
            />
        </div>
    );
}
